import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activities-pretrip',
  templateUrl: './activities-pretrip.component.html',
  styleUrls: ['./activities-pretrip.component.scss']
})
export class ActivitiesPretripComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
